const getSaveData = (scene: any): string => {
  const parts = [];

  for (let i = 0; i < scene.children.length; i++) {
    if (scene.children[i].name.includes('WallLine')) {
      scene.children[i].updateMatrixWorld();
      parts.push({
        name: scene.children[i].name.split(' ')[0],
        wallID: scene.children[i].name.split(' ')[1],
        wallProps: scene.children[i].properties,
        position: scene.children[i].position,
        xRot: (scene.children[i].rotation.x * 180) / Math.PI,
        yRot: (scene.children[i].rotation.y * 180) / Math.PI,
        zRot: (scene.children[i].rotation.z * 180) / Math.PI,
        roofProfilesAreas: scene.children[i].roofProfilesAreas,
        roofInternalProfilesAreas: scene.children[i].roofInternalProfilesAreas,
        lidProfilesAreas: scene.children[i].lidProfilesAreas,
        floorProfilesAreas: scene.children[i].floorProfilesAreas,
        wallComponents: scene.children[i].wallComponents,
        matrix: scene.children[i].matrixWorld,
      });

      continue;
    }

    if (scene.children[i].name.includes('GlassMeetingSign')) {
      //        let Connection = scene.getObjectByName('Connection ' + scene.children[i].name.split(' ')[1]);
      parts.push({
        name: scene.children[i].name,
        connProps: scene.children[i].properties,
        position: scene.children[i].position,
        xRot: (scene.children[i].rotation.x * 180) / Math.PI,
        yRot: (scene.children[i].rotation.y * 180) / Math.PI,
        zRot: (scene.children[i].rotation.z * 180) / Math.PI,
      });
    }
  }

  return JSON.stringify(parts);
};

export default getSaveData;
